(()=>{
  const mount=()=>{
    const root=document.getElementById('MRBrands');
    if(!root||root.dataset.directoryReady)return;
    root.dataset.directoryReady='true';
    const toggle=root.querySelector('.mr-brands-toggle');
    const searchBox=root.querySelector('.mr-brands-search');
    const input=root.querySelector('input[type="search"]');
    const grid=root.querySelector('.mr-brands-grid');
    const other=root.querySelector('.mr-brands-name-grid');
    const otherSection=root.querySelector('.mr-brands-other');
    const status=root.querySelector('.mr-brands-status');
    const featured=new Set([...grid.children].map(x=>x.dataset.brandKey));
    let expanded=false,loaded=false,busy=false;
    const fold=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/[^a-z0-9]/g,'');
    const filter=()=>{
      const query=fold(input.value.trim());
      let count=0;
      for(const card of [...grid.children,...other.children]){
        const visible=expanded?fold(card.dataset.brandSearch||card.dataset.brandName).includes(query):featured.has(card.dataset.brandKey);
        card.hidden=!visible;
        if(visible)count++;
      }
      otherSection.hidden=!expanded||![...other.children].some(x=>!x.hidden);
      grid.hidden=![...grid.children].some(x=>!x.hidden);
      status.textContent=count?root.dataset.count.replace('__count__',count):root.dataset.noResults;
    };
    const createCard=brand=>{
      const card=document.createElement('a');
      card.className='mr-brand-card';card.dataset.brandKey=brand.key;card.dataset.brandName=brand.name;card.dataset.brandSearch=brand.terms;
      card.href=brand.href;card.setAttribute('aria-label',root.dataset.explore.replace('__brand__',brand.name));
      if(brand.logo){
        const image=document.createElement('img');image.src=brand.logo;image.width=180;image.height=72;
        image.alt='';image.loading='lazy';image.decoding='async';
        if(brand.monochrome)image.dataset.monochrome='true';
        image.addEventListener('error',()=>image.remove(),{once:true});card.append(image);
      }else card.className='mr-brand-name-link';
      const label=document.createElement('span');label.textContent=brand.name;card.append(label);return card;
    };
    toggle.addEventListener('click',async()=>{
      if(busy)return;
      expanded=!expanded;toggle.setAttribute('aria-expanded',String(expanded));
      toggle.querySelector('span').textContent=expanded?root.dataset.featured:root.dataset.all;
      searchBox.hidden=!expanded;
      if(expanded&&!loaded){
        busy=true;toggle.setAttribute('aria-busy','true');status.textContent=root.dataset.loading;
        try{
          const response=await fetch(root.dataset.directoryUrl,{credentials:'omit'});
          if(!response.ok)throw Error('directory');
          const brands=await response.json();const fragment=document.createDocumentFragment(),names=document.createDocumentFragment();
          for(const brand of brands)if(!featured.has(brand.key))(brand.logo?fragment:names).append(createCard(brand));
          grid.append(fragment);other.append(names);loaded=true;
        }catch{
          expanded=false;searchBox.hidden=true;toggle.setAttribute('aria-expanded','false');
          toggle.querySelector('span').textContent=root.dataset.all;status.textContent=root.dataset.loadError;
        }finally{busy=false;toggle.removeAttribute('aria-busy');}
      }
      if(loaded||!expanded){if(!expanded)input.value='';filter();}
    });
    input.addEventListener('input',filter);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();

